<template>
  <div class="change-state-form bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
    <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
      <div class="ml-4 mt-4">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Generate Map PDF
        </h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">
          All of the {{ modelPrettified }} that have been selected will be included in map request.
        </p>
      </div>
    </div>
    <div class="modal-body">
      <div v-if="errors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="(error, idx) in errors" :key="idx">{{ error }} </li>
        </ul>
      </div>
      <div class="p-6 standard-form">
        <button class="mt-2 btn text-black" @click="showOptions = !showOptions">{{ optionTitle }}</button>
        <Transition>
          <div v-if="showOptions">
            <div class="standard-field-wrapper">
              <label for="includeEntitiesCheckbox">Include TTI CP data?</label>
              <div class="standard-input-wrapper">
                <div class="standard-input-container w-32">
                  <input type="checkbox" id="includeEntitiesCheckbox" v-model="includeEntities"/>
                </div>
              </div>
            </div>
            <div class="standard-field-wrapper">
              <label for="includeSurveyDataCheckbox">Include COTW survey data?</label>
              <div class="standard-input-wrapper">
                <div class="standard-input-container w-32">
                  <input type="checkbox" id="includeSurveyDataCheckbox" v-model="includeSurveyData"/>
                </div>
              </div>
            </div>
            <div class="standard-field-wrapper">
              <label for="includePaulNamesCheckbox">Include Trainer Names?</label>
              <div class="standard-input-wrapper">
                <div class="standard-input-container w-32">
                  <input type="checkbox" id="includePaulNamesCheckbox" v-model="includePaulNames"/>
                </div>
              </div>
            </div>
            <div class="standard-field-wrapper">
              <label for="printOptionSelect">Type of Report</label>
              <div class="standard-input-wrapper">
                <div class="standard-input-container w-32">
                  <select v-model="printOption" id="printOptionSelect">
                    <option value="default">Full Report</option>
                    <option value="secure_map">Secure Report (all sensitive info removed)</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
      <div class="action-buttons">
        <button type="button" class="btn btn-danger" @click="close()">Cancel</button>
        <button type="button" class="btn btn-primary" @click="submit" >Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { startCase } from 'lodash-es'
  import Multiselect from 'vue-multiselect'
  import BulkActionService from '@services/BulkActionService'
  import FlashMessages from '@services/FlashMessages'

  export default {
    name: 'assign-reporting-entities-form',
    components: {
      Multiselect,
    },
    data () {
      return {
        includeEntities: true,
        includeSurveyData: true,
        includePaulNames: true,
        printOption: 'default',
        errors: [],
        showOptions: false,
      }
    },
    computed: {
      modelPrettified () {
        return startCase(this.model)
      },
      showReasonText () {
        console.log(this.reasonCode)
        return (this.reasonCode == 'other') ? true : false
      },
      reasonCode () {
        console.log(this.selectedReason)
        return this.selectedReason ? this.selectedReason.toLowerCase() : ''
      },
      hasErrors () {
        return this.errors.length > 0
      },
      optionTitle () {
        return this.showOptions ? 'Hide Options' : 'Show Options'
      },
      requestOptions () {
        return {
        include_entities: this.includeEntities ? 'True' : 'False',
        include_surveys: this.includeSurveyData ? 'True' : 'False',
        include_paul_names: this.includePaulNames,
        print_option: this.printOption
        }

      }
    },
    methods: {
      cancel () {
        this.$emit('cancel')
      },
      close () {
        this.$emit('close')
      },
      checkForErrors () {
        this.errors = []
        if (!this.selectedReason) {
          this.errors.push('Please select a reason from the drop down')
        }
        if (this.reasonCode == 'other' && !this.other_reason_text ) {
          this.errors.push('Please add an explanation of Other.')
        }
        

      },
      submit () {
        this.processing = true
        BulkActionService.generateMapPdf(this.ids, this.model, this.requestOptions)
          .then(resp => {
            FlashMessages.success(`Successfully created map job.`, 'Success')
            this.close()
          })
          .catch(resp => {
            FlashMessages.error(`Failed to create map job. Please try again later.`, 'Error')
            this.close()
          })
      },
    },
    created () {
      console.log(this.model)
      console.log(this.ids)
    },
    props: {
      ids: {
        type: Array,
        required: true,
      },
      model: {
        type: String,
        required: true,
      },
      options: {
        type: Object,
        required: false,
      },
    },
  }
</script>

<style lang="scss">
  .change-state-form {
    .modal-body {
      margin-top: 15px;

      .action-buttons {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
      }
      .multiselector {
        margin-top: 5px;
        min-width: 20rem;
        max-width: 20rem;
      }
    }
  }
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
